import React from "react";
import ReactDOM from "react-dom/client";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router";

import { initTeams } from "common/teams";
import { initialState } from "app/store/InitialState";
import App from "./app/App";
import config from "./config/config";
import createAppStore from "./app/store";
import ToastNotificationProvider from "./components/toastNotification/context/ToastNotificationProvider";

const store = createAppStore(initialState);

initTeams();

Bugsnag.start({
  apiKey: config.bugsnagApiKey,
  plugins: [new BugsnagPluginReact()],
  releaseStage: config.stage,
  enabledReleaseStages: ["production", "test"],
  collectUserIp: false,
  onBreadcrumb: (breadcrumb) => {
    if (breadcrumb.type === "user") {
      breadcrumb.metadata.targetText = "HIDDEN";
    }
  }
});

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

const container = document.getElementById("app");
const root = ReactDOM.createRoot(container);

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ToastNotificationProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </ToastNotificationProvider>
    </Provider>
  </ErrorBoundary>
);
